import { render, staticRenderFns } from "./AddArticleExstingEdit.vue?vue&type=template&id=815294ec&scoped=true"
import script from "./AddArticleExstingEdit.vue?vue&type=script&lang=js"
export * from "./AddArticleExstingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815294ec",
  null
  
)

export default component.exports